<script>
import beforeBind from '@/assets/img/beforeBind.png'
export default {
  name: "venueList",
  data() {
    return {
      active: 0,
      beforeBindImg: beforeBind,
      typeList: [
        { name: '空间类型1', id: 1 },
        { name: '空间类型2', id: 2 },
        { name: '空间类型3', id: 3 },
        { name: '空间类型4', id: 4 },
        { name: '空间类型5', id: 5 },
        { name: '空间类型6', id: 6 },
        { name: '空间类型7', id: 7 },
        { name: '空间类型8', id: 8 }
      ],
      list: [],
      loading: false,
      finished: false,
    };
  },
  methods: {
    changeTab() {
      console.log(1, '=======')
    },
    onLoad() {
      // 异步更新数据
      // setTimeout 仅做示例，真实场景中一般为 ajax 请求
      setTimeout(() => {
        for (let i = 0; i < 10; i++) {
          this.list.push({ name: '空间名称', remark: '空间描述空间描述空间描述空间描述空间描述空间描述空间描述空间描述空间描述空间描述空间描述空间描述空间描述空间描述空间描述空间描述空间描述空间描述空间描述空间描述', id: i });
        }

        // 加载状态结束
        this.loading = false;

        // 数据全部加载完成
        if (this.list.length >= 40) {
          this.finished = true;
        }
      }, 1000);
    },
    back() {
      this.$router.go(-1)
    },
  }
}
</script>

<template>
  <div class="venue-list">
    <van-nav-bar title="空间列表" left-arrow @click-left="back" />
    <van-tabs v-model="active" @change="changeTab">
      <van-tab v-for="item in typeList" :title="item.name" :key="item.id">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <template v-if="list.length > 0">
            <div v-for="item in list" :key="item.id" class="venue-item">
              <div class="venue-item-img">
                <img :src="beforeBindImg" alt="" />
              </div>
              <div class="venue-item-content">
                <div class="venue-item-title">{{ item.name }}</div>
                <div class="venue-item-remark">{{ item.remark }}</div>
                <div class="venue-item-btn-area">
                  <div class="venue-item-btn">预约</div>
                </div>
              </div>
            </div>
          </template>
          <div v-else class="venue-empty">
            <svg-icon icon-class="empty" class-name="venue-empty-icon" />
            <div class="venue-empty-tips">当前时段没有空闲空间， </div>
            <div class="venue-empty-tips">您可以换个预约时间后重试</div>
            <div class="venue-empty-btn">更换时间</div>
          </div>
        </van-list>
      </van-tab>
    </van-tabs>
  </div>
</template>

<style scoped lang="less">
.change_val(@name, @px){
    @{name}: @px / 200.6 * 1rem;
}
.change_margin(@name, @top, @right){
    @{name}: @top / 200.6 * 1rem @right / 200.6 * 1rem;
}
  .venue-list {
    height: 100vh;
    /deep/.van-tabs,
    .van-tabs__wrap {
      height: 0.47rem;
      .van-tabs__nav {
        background: rgba(250, 250, 250, 1);
      }
      .van-tabs__nav--line {
        color: #3b86ff;
      }
      .van-tab {
        color: #333;
      }
      .van-tab--active {
        color: #3b86ff;
      }
      .van-tabs__line {
        background-color: #3b86ff;
      }
      .van-tab__text--ellipsis {
        overflow: unset;
      }
    }

    .venue-item {
      display: flex;
      background: #FFFFFF;
      box-shadow: 0px 0px 10px 0px rgba(159,203,222,0.5);
      .change_val(border-radius, 18);
      font-weight: 500;
      .change_val(margin-top, 30);
      .change_val(margin-left, 30);
      .change_val(margin-right, 30);

      .venue-item-img {
        img {
          .change_val(width, 230);
          .change_val(height, 230);
          .change_margin(margin, 20, 20);
        }
      }

      .venue-item-content {
        .change_val(padding-top, 30);
        .change_val(padding-right, 28);
        .venue-item-title {
          .change_val(font-size, 32);
        }
        .venue-item-remark {
          color: #999999;
          display: -webkit-box;
          -webkit-line-clamp: 2; /* 限制在一个块元素显示的文本的行数 */
          -webkit-box-orient: vertical;
          overflow: hidden;
          .change_val(line-height, 33);
          .change_val(margin-top, 10);
          .change_val(height, 66);
        }
        .venue-item-btn-area {
          display: flex;
          justify-content: flex-end;
          .change_val(margin-top, 25);
          .venue-item-btn {
            .change_val(width, 138);
            .change_val(height, 74);
            .change_val(font-size, 30);
            .change_val(border-radius, 40);
            color: #ffffff;
            background: linear-gradient( 347deg, #00C9FF 0%, #1677FF 100%);
            display: flex;
            justify-content: center;
            align-items: center;
          }
        }
      }
    }

    .venue-empty {
      background: #FFFFFF;
      box-shadow: 0px 0px 10px 0px rgba(102,102,102,0.25);
      .change_margin(margin, 30, 30);
      .change_val(border-radius, 30);
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      .venue-empty-icon {
        .change_val(width, 175);
        .change_val(height, 173);
        .change_val(margin-top, 90);
        .change_val(margin-bottom, 30);
      }

      .venue-empty-tips {
        color: #999999;
        .change_val(font-size, 24);
      }

      .venue-empty-btn {
        display: flex;
        align-items: center;
        justify-content: center;
        border: 2px solid #1677FF;
        color: #1677FF;
        .change_val(width, 280);
        .change_val(height, 80);
        .change_val(font-size, 32);
        .change_val(border-radius, 40);
        .change_val(margin-top, 40);
        .change_val(margin-bottom, 84);
      }
    }
  }
</style>
